import { LinkInterface } from '@/domain/interface/LinkInterface';

export class EindbeoordelingCommonFieldsClass {
  uitvoerderActiviteitOwner: boolean;
  erkenningsnummer?: string;
  uitvoerderNaam?: string;
  opmerking?: string;
  links?: LinkInterface;

  constructor(eindbeoordeling?: EindbeoordelingCommonFieldsClass) {
    this.uitvoerderActiviteitOwner =
      eindbeoordeling?.uitvoerderActiviteitOwner || false;
    this.erkenningsnummer = eindbeoordeling?.erkenningsnummer;
    this.uitvoerderNaam = eindbeoordeling?.uitvoerderNaam;
    this.opmerking = eindbeoordeling?.opmerking;
    this.links = eindbeoordeling?.links;
  }
}
